import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { dateCalendarFormatType, currentFormatTime, dateFormat } from 'src/utils/dateSet';
import { addComma } from 'src/utils/common';
import NoResult from 'src/components/molecules/table/NoResult';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = data || [];
  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };

  const viewDataType = (item: any) => {
    let typeView = '';
    switch (item) {
      case 'PN001':
        typeView = '국민연금(지역가입자)';
        break;
      case 'PH001':
        typeView = '기타건강보험';
        break;
      case 'PS001':
        typeView = '사립학교교직원연금(추가납입분)';
        break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };

  return (
    <div className="_table_grid_layout _national_pension_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n1">
              <div className="_cont">유형</div>
            </div>
            <div className="_col _wd_n4">
              <div className="_cont">국세청 자료</div>
            </div>
            <div className="_col _wd_n0">
              <div className="_cont">금액(국세청)</div>
            </div>
            <div className="_col _wd_n0">
              <div className="_cont">금액(일반)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item || {};

            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n1">
                  <div className="_cont">{viewDataType(infoData.data_type)}</div>
                </div>
                <div className="_col _wd_n4">
                  <div className="_cont">{infoData.is_htx_pdf === 'Y' ? '국세청제공' : '-'}</div>
                </div>
                <div className="_col _wd_n0">
                  <div className="_cont">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n0">
                  <div className="_cont">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
